import { render, staticRenderFns } from "./baking.vue?vue&type=template&id=46490906&scoped=true&"
import script from "./baking.vue?vue&type=script&lang=js&"
export * from "./baking.vue?vue&type=script&lang=js&"
import style0 from "./baking.vue?vue&type=style&index=0&id=46490906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46490906",
  null
  
)

export default component.exports